import styled from 'styled-components';

export const Container = styled.div`
  background-color: oklch(0.9842 0.0034 247.86);
  border-radius: 12px;
  padding: 12px 16px;
  margin: 8px auto 32px;
  direction: rtl;
  text-align: right;
  border: 1px solid oklch(0.9288 0.0126 255.51);
  max-width: 1200px;
  width: 95%;

  @media (max-width: 768px) {
    width: 90%;
    padding: 12px 16px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;
  
  &:hover {
    opacity: 0.8;
  }
`;

export const Title = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: oklch(0.3717 0.0392 257.29);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 768px) {
    font-size: 0.9375rem;
  }
`;

export const ToggleIcon = styled.div<{ $isExpanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: oklch(55.44% 0.041 257.42);
  transition: transform 0.3s ease;
  transform: rotate(${props => props.$isExpanded ? '180deg' : '0deg'});
`;

export const Content = styled.div<{ $isExpanded: boolean }>`
  max-height: ${props => props.$isExpanded ? '1000px' : '0'};
  overflow: hidden;
  transition: max-height 0.3s ease;
`;


export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 768px) {
    gap: 14px;
    padding-top: 12px;
  }
`;

export const ListItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  color: oklch(55.44% 0.041 257.42);
  font-size: 14px;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 0.75rem;
    gap: 12px;
    line-height: 1.5;
  }
`;

export const IconWrapper = styled.div`
  min-width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: oklch(0.7107 0.0351 256.79);
  margin-top: 2px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    min-width: 20px;
    height: 20px;
    margin-top: 0;

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;
